import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthStateService } from '../services/auth-state.service';

export const authGuard: CanActivateFn = () => {
  const authState = inject(AuthStateService);
  const router = inject(Router);

  authState.checkSession();

  if (authState.isAuthenticated()) {
    if (authState.hasAccess()) {
      return true;
    }
    return router.createUrlTree(['/login'], {
      queryParams: { reason: 'unauthorized' }
    });
  }

  return router.parseUrl('/login');
};
